/* global Vimeo:true */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import Title from '../icons/Title';
import Button from '../buttons/Button';
import GoteborgIcon from '../icons/festivals/Goteborg';
import HotDocsIcon from '../icons/festivals/HotDocs';
import DoxaIcon from '../icons/festivals/Doxa';

import styles from '../../../styles/partials/hero.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Hero = ({ className }) => {
    const [trailerOpened, setTrailerOpened] = useState(false);
    const refPlayer = useRef(null);
    const refIframe = useRef(null);
    const onTrailerClick = useCallback(() => {
        if (refPlayer.current !== null) {
            refPlayer.current.play();
        }
        setTrailerOpened(true);
    }, []);
    const onClickClose = useCallback(() => {
        if (refPlayer.current !== null) {
            refPlayer.current.pause();
        }
        setTrailerOpened(false);
    }, []);

    useEffect(() => {
        const player = new Vimeo.Player(refIframe.current);
        refPlayer.current = player;
    }, []);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.trailerOpened]: trailerOpened,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.splash}>
                <div className={styles.content}>
                    <div className={styles.presents}>Catbird Films presents</div>
                    <h1 className={styles.title}>
                        <Title className={styles.logo} />
                    </h1>
                    <div className={styles.filmBy}>A film by Tamara Mariam Dawit</div>
                    <div className={styles.actions}>
                        <Button className={styles.button} onClick={onTrailerClick}>
                            Watch trailer
                        </Button>
                    </div>
                    <div className={styles.festivals}>
                        <ul className={styles.items}>
                            <li className={styles.item}>
                                <GoteborgIcon className={styles.icon} />
                            </li>
                            <li className={styles.item}>
                                <HotDocsIcon className={styles.icon} />
                            </li>
                            <li className={styles.item}>
                                <DoxaIcon className={styles.icon} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className={styles.synopsis}>
                <div className={styles.inner}>
                    <p>
                        <strong>Finding Sally</strong> tells the incredible story of a 23-year-old
                        woman from an upper-class family who became a communist rebel with the
                        Ethiopian People’s Revolutionary Party. Idealistic and in love, Sally got
                        caught up in her country’s revolutionary fervour and landed on the military
                        government’s most wanted list. She went underground and her family never saw
                        her again.
                    </p>

                    <p>
                        Four decades after Sally’s disappearance, Tamara Dawit pieces together the
                        mysterious life of her aunt Sally. She revisits the Ethiopian Revolution and
                        the terrible massacre that followed, which resulted in nearly every
                        Ethiopian family losing a loved one. Her quest leads her to question notions
                        of belonging, personal convictions and political ideals at a time when
                        Ethiopia is going through important political changes once again.
                    </p>
                </div>
            </div>
            <div className={styles.modal}>
                <iframe
                    src="https://player.vimeo.com/video/383336742"
                    width="640"
                    height="360"
                    frameBorder="0"
                    className={styles.iframe}
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title="Trailer"
                    ref={refIframe}
                />
                <button type="submit" onClick={onClickClose} className={styles.block} />
                <button type="submit" onClick={onClickClose} className={styles.close}>
                    &times;
                </button>
            </div>
        </div>
    );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
